import { render } from "./CrossStep4InCorso.vue?vue&type=template&id=77038cfe"
import script from "./CrossStep4InCorso.vue?vue&type=script&lang=js"
export * from "./CrossStep4InCorso.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__